import axios, { AxiosError } from "axios";
const TenantTimeSlotGroupResource = {
    get(tenantId, timeSlotGroupId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/tenants/${tenantId}/time-slot-groups/${timeSlotGroupId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    search(tenantId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/tenants/${tenantId}/time-slot-groups`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(tenantId, timeSlotGroupId, updateRequest, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/tenants/${tenantId}/time-slot-groups/${timeSlotGroupId}`, updateRequest)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(tenantId, createRequest, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/tenants/${tenantId}/time-slot-groups`, createRequest)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    delete(tenantId, timeSlotGroupId, resultFunc, errorFunc, finallyFunc) {
        axios.delete(`/admin/v1/tenants/${tenantId}/time-slot-groups/${timeSlotGroupId}`)
            .then(( /*response*/) => resultFunc())
            .catch(errorFunc)
            .finally(finallyFunc);
    }
};
export default TenantTimeSlotGroupResource;
